import React from 'react';

interface INoResultsSection {
  message: string;
}

const NoResultsSection: React.FC<React.PropsWithChildren<INoResultsSection>> = ({
  message,
  children,
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-full bg-gray-100 rounded-lg h-80 md:h-96 md:mt-6">
      <p className="mb-8 font-normal text-center mx-1/6 text-600 highlight md:mx-0">{message}</p>
      {children}
    </div>
  );
};

export default NoResultsSection;
